"use client";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import { useEventRuntime } from "@/components/events/event-runtime";
import { useBidRuntime } from "./bid-runtime";

export function BidOperationNotices() {
  const t = useTranslations("bids");
  const runtime = useBidRuntime(),
    event = useEventRuntime();
  if (
    !runtime.ready ||
    (runtime.available && !runtime.records.length && !runtime.terminal)
  )
    return null;
  return (
    <aside
      data-slot="bid-operation-notices"
      data-debug-source="src/components/bidding/bid-operation-notices.tsx"
      className="m-4 space-y-3 rounded-lg border border-warning-border bg-warning-soft p-4 text-sm text-warning-foreground sm:mx-6"
      aria-live="polite"
    >
      {!runtime.available ? (
        <div className="space-y-2">
          <p>{t("storageBlocked")}</p>
          <Button variant="outline" onClick={runtime.restore}>
            {t("checkStorage")}
          </Button>
        </div>
      ) : null}
      {runtime.records.map((record) => (
        <div key={record.idempotencyKey} className="space-y-2">
          <p>{t("unknownOperation")}</p>
          <div className="flex flex-wrap gap-2">
            <Button
              variant="outline"
              disabled={runtime.pending}
              onClick={() => void runtime.lookup(record)}
            >
              {t("checkResult")}
            </Button>
            <Button asChild variant="ghost">
              <Link
                href={
                  event.binding.audience === "supplier"
                    ? `/supplier/events/${record.eventId}`
                    : `/sourcing/${record.eventId}`
                }
              >
                {t("viewEvent")}
              </Link>
            </Button>
          </div>
        </div>
      ))}
      {runtime.lookupFailed ? <p role="alert">{t("lookupFailed")}</p> : null}
      {runtime.terminal ? (
        <div className="space-y-2">
          <p>{t(`terminal${runtime.terminal}`)}</p>
          <Button variant="outline" onClick={runtime.dismiss}>
            {t("dismiss")}
          </Button>
        </div>
      ) : null}
    </aside>
  );
}
